import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedVideos from './components/FeaturedVideos';
import FeaturesBanner from './components/FeaturesBanner';
import LatestArticles from './components/LatestArticles';

export default function Home() {
  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '西瓜视频 - 高清免费在线播放平台',
    description: '西瓜视频提供蜜桃视频、红桃视频、樱桃视频等高清在线播放，无需下载插件，手机电脑网页直接观看，流畅不缓冲。最新影视剧集实时更新，免费追剧体验。',
    url: 'https://www.xigua-video.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '西瓜视频',
      url: 'https://www.xigua-video.com/',
    },
  };

  const searchActionSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '西瓜视频',
    url: 'https://www.xigua-video.com/',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.xigua-video.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(searchActionSchema) }}
      />
      <main role="main">
        <HeroSection />
        <CategoryGrid />
        <FeaturedVideos />
        <FeaturesBanner />
        <LatestArticles />
      </main>
    </>
  );
}